import DashBoardQRCode from './DashBoardQRCode';
export default DashBoardQRCode;
